import React from 'react'

const NotFound = ({notfound}) => {

    return (
        <div>
        <h1>404.. This page is not found!</h1>
        </div>
    ) 
  }
  
  export default NotFound



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js